import { FC, memo } from 'react';
import { Skeleton } from '../../../dumb/Skeleton';
import { CurrencyLabel } from '../../../composite/CurrencyLabel';

type TableOfBidsProps = {
    showLoading?: boolean;
    tableRowData: any[];
    showPaddleNumber: boolean;
    paddleNumber: string;
    bidTableRef: any;
}

const TableOfBids: FC<TableOfBidsProps> = ({ showLoading = false, tableRowData, showPaddleNumber, paddleNumber, bidTableRef }) => {

    if (showLoading) return <Skeleton animation="wave" variant="rectangular" height="120px" width="100%" style={{ borderRadius: 12 }} />;

    return (
        <div className="pb-bids">
            <div className="pb-bids-heading">Bids</div>
            <div className="pb-bids-list" ref={bidTableRef}>
                {tableRowData.length === 0 && <div className="pb-bids-empty">No bids yet</div>}
                {tableRowData.map((bid, idx) => {
                    const mine = !!paddleNumber && bid?.paddleNumber === paddleNumber;
                    return (
                        <div key={idx} className={"pb-bids-row" + (mine ? " pb-bids-row--mine" : "")}>
                            <span className="pb-bids-paddle">
                                {showPaddleNumber ? bid?.paddleNumber + (mine ? "  (you)" : "") : mine ? "You" : "Bid"}
                            </span>
                            <span className="pb-bids-amount">
                                <CurrencyLabel value={bid?.amount} textColour={mine ? "var(--primary)" : "var(--ink)"} />
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default memo(TableOfBids);
